import { call, put, takeEvery, } from "redux-saga/effects";

// Crypto Redux States
import { addNoticeType, getNoticeTypeList, editNoticeType, noticeTypeEditStatus, noticeTypeDelete } from "../../helpers/api";
import { ADD_NOTICE_TYPE, GET_NOTICE_TYPE_LIST, EDIT_NOTICE_TYPE, EDIT_NOTICE_TYPE_STATUS, DELETE_NOTICE_TYPE } from "./actionTypes";
import { NoticeTypeListResponce } from "./actions";

//Include Both Helper File with needed methods
import { showToast } from "../toast/actions";


/**
 * Generator function that adds a notice using the provided data and token.
 * @param {Object} payload - The payload object containing the data and token.
 * @param {Object} success - The success callback function.
 * @param {Object} failure - The failure callback function.
 * @returns None
 */
function* addNoticetype({ payload: { data}, success, failure}){
  try {
    const response = yield call(addNoticeType, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }
}


/**
 * Generator function that retrieves a list of notices.
 * @param {Object} payload - The payload object containing the token.
 * @param {string} payload.token - The authorization token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* noticeTypeList( { payload: { data }, success, failure }){

  try {
    const responce = yield call(getNoticeTypeList, data)
    if (responce){
      yield put(NoticeTypeListResponce(responce));
      success(responce)
    }
    
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }

}

/**
 * Generator function that handles editing a notice.
 * @param {object} payload - The payload object containing the notice ID, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* editNoticetype({ payload: { id, data}, success, failure}){
  try {
    const response = yield call(editNoticeType, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that handles the editing of a notice's status.
 * @param {object} payload - The payload object containing the notice ID, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* noticeEditTypestatus({ payload: { id, data}, success, failure}){

  try {
    const response = yield call(noticeTypeEditStatus, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that handles the deletion of a notice.
 * @param {object} payload - The payload object containing the notice ID, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* noticeTypedelete({ payload: { id }, success, failure}){

  try {
    const response = yield call(noticeTypeDelete, id);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

function* noticeType() {
     yield takeEvery(ADD_NOTICE_TYPE, addNoticetype);
     yield takeEvery(GET_NOTICE_TYPE_LIST, noticeTypeList);
    yield takeEvery(EDIT_NOTICE_TYPE, editNoticetype);
    yield takeEvery(EDIT_NOTICE_TYPE_STATUS, noticeEditTypestatus);
    yield takeEvery(DELETE_NOTICE_TYPE, noticeTypedelete);
}

export default noticeType;
